import React from 'react';

const Appointment = () => {
    return (
        <div>
            <h2>Dashboard</h2>
        </div>
    );
};

export default Appointment;